import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 事前登録情報の型
 */
export interface PreRegistrationType {
    artwork_id: string,
    country_name: string,
    educational_institution_country_name: string,
    poster: string,
    birthday: string,
    educational_institution: string,
    mailaddress: string,
    group_flg: string,
}

/**
 * 事前登録情報Hook
 * 対象年度の事前登録情報を取得する
 * @param year 対象年度
 */
export function usePreRegistration(year?:string) {

    const fetchAddress = `/competition/api/management/preregistration?targetyear=${year}&sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress).then(res => res.json());

    const {data, error, isLoading, mutate} = useSWR(`PreRegistration${year}`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 事前登録情報配列
         */
        preRegistration: data,

        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}